import { render } from "./CatalogoServicios.vue?vue&type=template&id=fb76ac92&scoped=true"
import script from "./CatalogoServicios.vue?vue&type=script&lang=js"
export * from "./CatalogoServicios.vue?vue&type=script&lang=js"

import "./CatalogoServicios.vue?vue&type=style&index=0&id=fb76ac92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb76ac92"]])

export default __exports__